<template>
    <v-row justify="center">
        <v-dialog
            v-model="showDialogue"
            @click:outside="close"
            transition="dialog-bottom-transition"
            max-width="540"
        >
            <v-alert border="top" colored-border type="warning" elevation="2" prominent>
                <v-row align="center">
                    <v-col class="grow">
                        <div class="mb-2">{{$vopsui.labels.idle()}}</div>
                        <div>{{$vopsui.labels.idleCountdown(dialogueCountdown.toString())}}</div>
                    </v-col>
                    <v-col class="shrink">
                        <v-btn
                            color="primary"
                            @click="close"
                            text
                        >
                            {{$vopsui.labels.continue()}}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-alert>
        </v-dialog>
    </v-row>
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
import IdleJs from "idle-js";

@Component
export default class Idler extends Vue {
    @Prop({default: 10}) idleTimeMinutes: number;
    @Prop() idleAction: () => Promise<void>;

    showDialogue: boolean = false;
    dialogueCountdown: number = 120;
    countTimerId: number;

    created() {
        const idle = new IdleJs({
            idle: this.idleTimeMinutes * 1000 * 60, // idle time in ms
            events: ['mousemove', 'keydown', 'mousedown', 'touchstart'], // events that will trigger the idle resetter
            onIdle: this.openDialogue, // callback function to be executed after idle time
            onActive: () => {}, // callback function to be executed after back form idleness
            onHide: () => {}, // callback function to be executed when window become hidden
            onShow: () => {}, // callback function to be executed when window become visible
            keepTracking: true, // set it to false if you want to be notified only on the first idleness change
            startAtIdle: false // set it to true if you want to start in the idle state
        });

        idle.start();
    }

    openDialogue() {
        if (this.showDialogue)
            return;

        this.showDialogue = true;
        this.dialogueCountdown = 120;
        this.countTimerId = window.setInterval(() => {
            if (this.dialogueCountdown > 0)
                this.dialogueCountdown--;

            if (this.dialogueCountdown == 0)
                this.idleAction();
        }, 1000);
    }

    close() {
        clearInterval(this.countTimerId);
        this.showDialogue = false;
    }
}
</script>

<style>
.v-dialog .v-alert {
    margin-bottom: unset !important;
}
</style>